import { observable, action } from 'mobx';
import axios from 'axios';
import { getCache } from '../helpers/cache';

class NhgRegulationStore {
  @observable accessor regulationNhg = '';
  @observable accessor regulationNhgWithEBM= '';

  constructor() {
    this.getNhgRegulationValues();

    this.getNhgRegulationValues = this.getNhgRegulationValues.bind(this);
  }

  @action
  async getNhgRegulationValues() {
    const res = await axios('/regulations/nhg');
    // const res = getCache('regulations/nhg');

    this.regulationNhgWithEBM = res.data.nhgWithEBM;
    this.regulationNhg = res.data.nhg;
  }
}

const NhgRegulationData = new NhgRegulationStore();

export default NhgRegulationData;
